import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { KanbanQueryParams } from '../types';

interface KanbanToolbarProps {
  filters: KanbanQueryParams;
  onFiltersChange: (filters: KanbanQueryParams) => void;
}

export function KanbanToolbar({ filters, onFiltersChange }: KanbanToolbarProps) {
  return (
    <div className="flex items-center gap-3">
      <Select
        value={filters.filter || 'all'}
        onValueChange={(value) => onFiltersChange({ ...filters, filter: value === 'all' ? undefined : value as KanbanQueryParams['filter'] })}
      >
        <SelectTrigger className="w-[140px]">
          <SelectValue placeholder="Period" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Time</SelectItem>
          <SelectItem value="this_week">This Week</SelectItem>
          <SelectItem value="this_month">This Month</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={filters.type || 'all'}
        onValueChange={(value) => onFiltersChange({ ...filters, type: value === 'all' ? undefined : value })}
      >
        <SelectTrigger className="w-[150px]">
          <SelectValue placeholder="Project Type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Types</SelectItem>
          <SelectItem value="installation">Installation</SelectItem>
          <SelectItem value="shipping">Shipping</SelectItem>
          <SelectItem value="calibration">Calibration</SelectItem>
          <SelectItem value="replacement">Replacement</SelectItem>
          <SelectItem value="quote">Quote</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
